<div class="keyboard-grid">
  <!-- Global -->
  <h3 class="keyboard-section">Global</h3>
  <div class="keyboard-key"><kbd class="mono">Shift</kbd><kbd class="mono">?</kbd></div>
  <div class="keyboard-description">Show the keyboard shortcuts.</div>
  <div class="keyboard-key"><kbd class="mono">Ctrl</kbd><kbd class="mono">Shift</kbd><kbd class="mono">F</kbd></div>
  <div class="keyboard-description">Go to dashboard search bar.</div>
  <div class="keyboard-key"><kbd class="mono">D</kbd></div>
  <div class="keyboard-description">Go to Dailies.</div>
  <div class="keyboard-key"><kbd class="mono">C</kbd></div>
  <div class="keyboard-description">Go to Currency.</div>
  <div class="keyboard-key"><kbd class="mono">H</kbd></div>
  <div class="keyboard-description">Go to Home / Dashboard.</div>
  <div class="keyboard-key"><kbd class="mono">E</kbd></div>
  <div class="keyboard-description">Go to Events.</div>
  <div class="keyboard-key"><kbd class="mono">I</kbd></div>
  <div class="keyboard-description">Go to Items.</div>
  <div class="keyboard-key"><kbd class="mono">R</kbd></div>
  <div class="keyboard-description">Go to Realms.</div>
  <div class="keyboard-key"><kbd class="mono">P</kbd></div>
  <div class="keyboard-description">Go to Spirits.</div>
  <div class="keyboard-key"><kbd class="mono">S</kbd></div>
  <div class="keyboard-description">Go to Seasons.</div>
  <div class="keyboard-key"><kbd class="mono">W</kbd></div>
  <div class="keyboard-description">Go to Winged Light.</div>

  <!-- Spirit Trees -->
  <h3 class="keyboard-section">Spirit Trees</h3>
  <div class="keyboard-key"><kbd class="mono">N</kbd></div>
  <div class="keyboard-description">Toggle Navigate mode.</div>
  <div class="keyboard-key"><kbd class="mono">U</kbd></div>
  <div class="keyboard-description">Toggle Unlock mode.</div>

  <!-- Overlays -->
  <h3 class="keyboard-section">Overlays</h3>
  <div class="keyboard-key"><kbd class="mono">Esc</kbd></div>
  <div class="keyboard-description">Close the overlay.</div>
</div>
